<!--
 * @Description: 通用登录页
 * 2025-05-21 有些客户要求 先出现询问区域 是访客还是老会员 如果是老会员 打开不同的页面
-->
<template>
	<div>
		<div :style="[getSelectModelStyle()]" v-if="show_select_model">
			<div>
				<div style="padding-top:150px;" @click="logo_jump">
					<img :src="project.setting.login.selectTopLogo" draggable="false"
						style="margin: auto;border-radius: 0px;height: 66px;">
				</div>
				<div style="margin-top:50px;">
					<ul style="    display: flex;justify-content: center;">
						<li @click="toRegist"
							style="padding: 10px; color: rgb(190, 163, 133); display: inline-flex; flex-direction: column; align-items: center; width: 170px;">
							<img :src="project.setting.login.selectNewLogo" draggable="false"
								style="border-radius: 0px; margin-bottom: 5px; height: 82px;width:82px;"><b
								style="font-weight: 800;">{{project.setting.login.selectNewTitle}}</b>
						</li>
						<li @click="to_login"
							style="padding: 10px; color: rgb(190, 163, 133); display: inline-flex; flex-direction: column; align-items: center; width: 170px;">
							<img :src="project.setting.login.selectOldLogo" draggable="false"
								style="border-radius: 0px; margin-bottom: 5px; height: 82px;width:82px;"><b
								style="font-weight: 800;">{{project.setting.login.selectOldTitle}}</b>
						</li>

					</ul>
				</div>

			</div>
		</div>

		<div class="login" :style="[getStyle()]" v-else>
			<!-- logo区域 -->
			<img :src="project.setting.login.logo" class="login-logo" v-if="project.setting.login.logo != undefined"
				:style="[logoStyle()]" />

			<ul class="flex-column col-center" :style="[whiteBg()]"> <!-- 此区域是账号密码登录按钮区域 用于给用户设置白色底框使用 -->

				<p class="loginTitle" v-if="project.setting.login.title!=''" :style="[titleStyle()]">
					{{ project.setting.login.title }}
				</p>

				<p class="loginTitle2" :style="[titleStyle2()]" v-if="project.setting.login.title2">
					{{ project.setting.login.title2 }}
				</p>

				<!-- 账号密码登录区域   -->
				<ul class="flex-column col-center" :style="[inputViewStyle()]">
					<div style="display: flex;width: 100%;justify-content: space-evenly;margin-bottom: 20px;">
						<div @click="selectedSms">
							<p :style="[loginModelSmsStyle()]">
								验证码登录
							</p>
						</div>
						<div @click="selectedPwd">
							<p :style="[loginModelPwdStyle()]">
								账号登录
							</p>
						</div>
					</div>

					<li class="login-field" :style="[inputUserStyle()]">
						<!-- <i class="icon icon-shouji"></i> -->
						<!-- 注意 不要写成 请输入账号或者手机号,否则小程序官方就会警告手机用户手机信息 -->
						<input type="text" class="telPwdCss" :style="[inputStyle()]" placeholder="请输入账号"
							v-model="account" />
					</li>

					<div v-if="project.setting.login.inputShowLine" class="line"></div>

					<li class="login-field" :style="[inputPwdStyle()]">

						<input type="password" v-if="login_model == 'pwd'" class="telPwdCss" :style="[inputStyle()]"
							:placeholder="pwdPlaceholder" v-model="password" />


						<input type="text" v-if="login_model == 'sms'" class="telPwdCss" :style="[inputStyle()]"
							:placeholder="pwdPlaceholder" v-model="password" style='width: 65%;' />

						<span class="text_sms" :style="[btnSmsStyle()]" @click="getCode()"
							:v-bind:disabled='btnDisabled' v-if="login_model == 'sms'">
							{{ btnTitle }}</span>


					</li>

					<div v-if="project.setting.login.inputShowLine" class="line"></div>

				</ul>

				<!-- 登录按钮区域 -->
				<button class="btn" :style="[btnStyle()]"
					@click="login">{{project.setting.login.btnTitle || ''}}</button>

				<!-- 用户协议 -->
				<div class="justify-evenly group_agreement">

					<div v-if="checked" class="checkbox_1" @click="toChecked" :style="[agreementSelectedStyle()]">
					</div>
					<div v-else class="checkbox_10" @click="toChecked" :style="[agreementUnselectStyle()]"></div>
					<li class="text_agreement" @click="toChecked">我已阅读并同意</li>
					<li class="text_agreement_2" @click="agreement1" :style="[agreementStyle()]">用户注册协议</li>
					<li class="text_agreement">和</li>
					<li class="text_agreement_2" @click="agreement2" :style="[agreementStyle()]">隐私协议</li>
				</div>

				<div class="justify-evenly group_regist" v-if="project.setting.login.showRegist">
					<li class="text_agreement" @click="toRegist" :style="[agreementStyle()]">还没有账号?请直接注册</li>

				</div>
			</ul> <!-- 此区域是账号密码登录按钮区域 用于给用户设置白色底框使用 -->

			<img :src="project.setting.login.logoBottom" class="login-bottom-logo"
				v-if="project.setting.login.logoBottom != undefined && project.setting.login.logoBottom != ''"
				:style="[logoBottomStyle()]" />

		</div>

	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		mapMutations,
		mapGetters
	} from "vuex";
	import {
		requestWpt,
		requestMall
	} from '@/utils/request'

	export default {
		name: "login",
		data() {
			return {
				show_select_model: false, //是否先显示用户
				login_model: 'sms', //登录模式 是sms还是pwd
				checked: false, //是否勾选了协议  小程序审核官方要求默认是不同意
				pwdPlaceholder: '请输入密码',
				userName: "微信会员", //微信的昵称
				userHeadImg: "https://mall.5izg.cn/upload/ico/default_avatar_male.png", //微信的头像
				account: "",
				password: "",
				sitenum: "",
				openid: '',
				appid: "",
				code: "",
				autoRegister: '0',
				userCode: '',
				btnDisabled: true, //获取验证码按钮是否可以点击
				btnTitle: '', //获取验证码按钮显示文字

			};
		},
		onShow() {
			// #ifdef MP
			uni.setBackgroundColor({ //ios手机下拉默认是白色 现在改为和主色调一致
				backgroundColor: this.project.config.maincolor1,
				backgroundColorTop: this.project.config.maincolor1,
				backgroundColorBottom: this.project.config.maincolor1
			});
			// #endif

		},
		onLoad(option) {
			console.log("login");
			let that = this;
			that.sitenum = uni.getStorageSync("sitenum"); // 客多赞商户号 option.sitenum;
			if (that.project.setting.login.showSelect) { //开启选择模式
				this.show_select_model = true;
			}


			// alert("接收参数：" + option.code);
			if (this.project.setting.login.showTelLogin) {
				this.login_model = "sms";
				this.pwdPlaceholder = "请输入验证码";
			} else {
				this.login_model = "pwd";
				this.pwdPlaceholder = "请输入密码";
			}

			////console.log("接收code参数：" + option.code + " 如果收到 表示是微信回调", this.project.setting.login.showTelLogin);
			//1判断是否登录
			//2判断是否处于微信中,如果是,
			//3是否拿到code

			that.openid = uni.getStorageSync("userOpenid");

			that.autoRegister = uni.getStorageSync("autoRegister");
			that.appid = uni.getStorageSync("appId");
			let runMode = uni.getStorageSync("runMode"); //1 h5  2小程序  3公众号
			////console.log("==============>登录页基本参数：运行模式:" + runMode + " 商户号:" + that.sitenum);
			if (runMode == "3") {
				const url = window.location.href //小程序下这部分需要屏蔽 这个是公众号用的!!!!!!!!!!!!!!!!
				const code = url.match(/=(\S*)&state=STATE#/)

				// if (code !== null) {			  
				//   const replaceUrl = 'http://' + window.location.host + '/#/callback/?code=' + code[1] + '&state=STATE'
				//   return location.replace(replaceUrl)
				// }

				//alert("接收参数code：" + code);
				if (code != null) { //如果能获得code，说明需要处理url并跳转，如果不能获得code，不用处理
					this.code = code[1];
				}

				this.init(); //页面加载以后初始化 获取微信公众号openid
			}

			console.log("==============>登录页  是否显示自动注册" + that.autoRegister);
			if (that.autoRegister == '1') {
				that.regist(); //直接调用自动注册
			}
		},

		computed: {
			...mapGetters(["project"]),
			disabled() {
				if (this.account && this.password) return false;
				return true;
			},
		},

		methods: {
			logo_jump() {
				this.$jump(this.project.setting.login.selectTopLogoJump);
			},
			to_login() {
				this.show_select_model = false;
			},
			//用户选择以什么角色进入的区域样式
			getSelectModelStyle() {
				let res = {};
				res.minHeight = '100vh';
				res.backgroundImage = 'url(' + this.project.setting.login.selectBgImg + ')';
				res.backgroundSize = 'cover';
				// res.color = this.styles.titleColor;
				return {
					...res,
				};
			},
			...mapMutations(["setToken"]),
			// async getSystemInfo() {
			// 	// 异步获取设备类型
			// 	uni.getSystemInfo({
			// 		success: function(info) {
			// 			////console.log('设备品牌：' + info.brand); // 设备品牌
			// 			////console.log('设备型号：' + info.model); // 设备型号
			// 			////console.log('设备像素比：' + info.pixelRatio); // 设备像素比
			// 			////console.log('操作系统类型：' + info.platform); // 操作系统类型
			// 			////console.log('用户操作系统版本：' + info.system); // 用户操作系统版本
			// 			////console.log('微信版本号：' + info.version); // 微信版本号
			// 		}
			// 	});
			// },
			//查看用户服务协议
			agreement1: function() {
				//如果有配置读取配置,没有则走默认
				uni.navigateTo({
					url: '/pages/index/booking/h5Wpt?url=/admin/yonghuzhucexieyi.html'
				});
			},
			//查看隐私政策
			agreement2: function() {
				//如果有配置读取配置,没有则走默认
				uni.navigateTo({
					url: '/pages/index/booking/h5Wpt?url=' + encodeURIComponent('/admin/yinsixieyi.html')
				});
			},
			//切换协议选择
			toChecked: function() {
				let selected = false;
				if (this.checked) {
					selected = false;
				} else {
					selected = true;
				}
				this.checked = selected;
			},

			async loginWx() {
				this.init();
			},

			selectedPwd() {
				this.login_model = "pwd";
				this.pwdPlaceholder = "请输入密码";

			},
			selectedSms() {
				this.login_model = "sms";
				this.pwdPlaceholder = "请输入验证码";
				//先弹出一段文字 告诉那边我们  \r\n这个换行符号在真机好用 模拟器不好用 勿担心
				let that = this;
				// let show_info =
				// 	'本系统内部使用, \r\n不对外开放! \r\n 如果您是我们的会员,请使用登记的手机号码进行登录, \r\n 您也可以联系顾问获取账号及密码进行登录. \r\n 您确认用手机验证码登录吗?';
				// uni.showModal({
				// 	title: '',
				// 	content: show_info,
				// 	success: async (res) => {
				// 		if (res.confirm) {
				// 			this.login_model = "sms";
				// 			this.pwdPlaceholder = "请输入验证码";
				// 		} else if (res.cancel) {

				// 		}
				// 	}
				// })


			},
			//短信验证码发送按钮样式
			btnSmsStyle() {
				console.log(this.project.setting.login.btnSmsBtnColor);
				let res = {};
				if (this.project.setting.login.btnSmsBtnColor != undefined && this.project.setting.login.btnSmsBtnColor !=
					'') {
					res.color = this.project.setting.login.btnSmsBtnColor;
				} else {

					if (this.project.setting.login.btnBgColor != undefined && this.project.setting.login.btnBgColor !=
						'') {
						res.color = this.project.setting.login.btnBgColor;
					}
				}
				return {
					...res
				}
			},
			//同意协议图
			agreementSelectedStyle() {
				////console.log('同意协议图--------->', this.project.setting.login.agreementSelected);
				return {
					background: 'url(' + this.project.setting.login.agreementSelected + ') 0% 0% / cover'
				}
			},
			//不同意协议图
			agreementUnselectStyle() {
				return {
					background: 'url(' + this.project.setting.login.agreementUnselect + ') 0% 0% / cover'
				}
			},
			//协议的字体颜色
			agreementStyle() {
				return {
					color: this.project.setting.login.btnBgColor,
				}
			},
			//背景图样式
			getStyle() {

				//页面的背景图
				return {
					'background-image': 'url(' + this.project.setting.login.bgImg + ')',
					'background-color': this.project.setting.login.backgroundColor,
					'min-height': '812px',
					'height': '100vh',
					backgroundSize: 'cover'
				}
			},
			// 顶部主logo样式
			logoStyle() {
				let res = {};
				if (this.project.setting.login.logoMarginTop != undefined && this.project.setting.login.logoMarginTop !=
					'') {
					res.marginTop = this.project.setting.login.logoMarginTop;
				}
				if (this.project.setting.login.logoMarginBottom != undefined && this.project.setting.login
					.logoMarginBottom != '') {
					res.marginBottom = this.project.setting.login.logoMarginBottom;
				} else {
					res.marginBottom = 0;
				}
				res.width = this.project.setting.login.logoWidth;
				res.height = this.project.setting.login.logoHeight;
				res.borderRadius = this.project.setting.login.logoRadius;
				return {
					...res

				}
			},
			// 底部logo样式
			logoBottomStyle() {
				let res = {};
				if (this.project.setting.login.logoBottomWidth != undefined && this.project.setting.login
					.logoBottomWidth != '') {
					res.width = this.project.setting.login.logoBottomWidth;
				}
				if (this.project.setting.login.logoBottomHeight != undefined && this.project.setting.login
					.logoBottomHeight != '') {
					res.height = this.project.setting.login.logoBottomHeight;
				}
				if (this.project.setting.login.logoBottomRadius != undefined && this.project.setting.login
					.logoBottomRadius != '') {
					res.borderRadius = this.project.setting.login.logoBottomRadius;
				}
				if (this.project.setting.login.logoBottomMarginTop != undefined && this.project.setting.login
					.logoBottomMarginTop != '') {
					res.marginTop = this.project.setting.login.logoBottomMarginTop;
				}
				return {
					...res
				}
				// return {
				// 	width: this.project.setting.login.logoBottomWidth,
				// 	height: this.project.setting.login.logoBottomHeight,
				// 	'border-radius': this.project.setting.login.logoBottomRadius,
				// 	marginTop: this.project.setting.login.logoBottomMarginTop,

				// }
			},
			//验证码登录选中
			loginModelSmsStyle() {
				let res = {};
				if (this.login_model == "sms") {
					res.color = this.project.setting.login.btnBgColor;
				} else {
					res.color = this.project.setting.login.btnSubColor;
				}
				return {
					...res
				}
			},
			//密码登录选中
			loginModelPwdStyle() {
				let res = {};
				if (this.login_model == "pwd") {
					res.color = this.project.setting.login.btnBgColor;
				} else {
					res.color = this.project.setting.login.btnSubColor;
				}
				return {
					...res

				}
			},
			// 登录页文字样式1
			titleStyle() {
				return {
					marginTop: this.project.setting.login.titleMarginTop,
					color: this.project.setting.login.titleFontColor,
				}
			},
			// 登录页文字样式2
			titleStyle2() {
				return {
					marginTop: this.project.setting.login.titleMarginTop2,
					color: this.project.setting.login.titleFontColor2,
					fontSize: this.project.setting.login.titleFontSize2,
					fontWeight: this.project.setting.login.titleFontWeight2,
				}
			},
			// 登录页账号密码登录按钮背景白色框
			whiteBg() {
				let cssData = {
					width: '100%' //必须设置100% 这样才不影响别的输入框和按钮的宽度
				};
				if (this.project.setting.login.showInputBg == '1') {
					cssData = {
						width: this.project.setting.login.showInputWidth,
						height: '724rpx',
						background: '#FFFFFF',
						boxShadow: '0px 0px 20px 0px rgba(227,227,227,0.58)',
						borderRadius: '20px',
					};
				}
				return cssData
			},
			// 账号密码登录区域样式
			inputViewStyle() {
				return {
					width: '100%',
					// height: this.project.setting.login.btnHeight,
					// width: this.project.setting.login.btnWidth,
					// color: this.project.setting.login.btnTitleColor,
					// fontSize: this.$unit(this.project.setting.login.btnTitleSize),
					// fontWeight: 400,
					// background: this.project.setting.login.btnBgColor,
					// borderRadius: `${this.project.setting.login.btnUpperRadius}px ${this.project.setting.login.btnUpperRadius}px ${this.project.setting.login.btnLowerRadius}px ${this.project.setting.login.btnLowerRadius}px`,
					marginTop: this.project.setting.login.inputMarginTop,
					marginBottom: this.project.setting.login.inputMarginBottom,

				}
			},
			// 账号输入框样式
			inputUserStyle() {
				return {
					display: 'flex',
					width: '90%',
					color: this.project.setting.login.inputPlaceholderColor, //输入框内的占位符文字的颜色   
					background: this.project.setting.login.inputBackground, // 'rgba(236, 247, 246, 1)',
					borderRadius: this.project.setting.login.inputRadius, //'10px',
					border: this.project.setting.login.inputBorder, //'1px solid #1A1A1A'
					height: this.project.setting.login.btnHeight, //输入框的高度目前和登录按钮高度一致
					marginTop: this.project.setting.login.userMarginTop,
					marginBottom: this.project.setting.login.userMarginBottom,
				}
			},
			// 密码输入框样式
			inputPwdStyle() {
				return {
					display: 'flex',
					width: '90%',
					color: this.project.setting.login.inputPlaceholderColor, //输入框内的占位符文字的颜色   
					background: this.project.setting.login.inputBackground, // 'rgba(236, 247, 246, 1)',
					borderRadius: this.project.setting.login.inputRadius, //'10px',
					border: this.project.setting.login.inputBorder, //'1px solid #1A1A1A'
					height: this.project.setting.login.btnHeight, //输入框的高度目前和登录按钮高度一致
					marginTop: this.project.setting.login.pwdMarginTop,
					marginBottom: this.project.setting.login.pwdMarginBottom,
				}
			},
			// 账号密码input样式  比如文字颜色 在深颜色背景下要用白字
			inputStyle() {
				return {
					'--placeholder-color': this.project.setting.login.inputPlaceholderColor, //输入框内的占位符文字的颜色   
					color: this.project.setting.login.inputColor,
					'text-align': this.project.setting.login.inputTextAlign

				}
			},

			// 按钮样式
			btnStyle() {
				return {
					height: this.project.setting.login.btnHeight,
					'line-height': this.project.setting.login.btnHeight,
					width: this.project.setting.login.btnWidth,
					color: this.project.setting.login.btnTitleColor,
					fontSize: this.project.setting.login.btnTitleSize + 'px',
					fontWeight: 400,
					background: this.project.setting.login.btnBgColor,
					borderRadius: `${this.project.setting.login.btnUpperRadius}px ${this.project.setting.login.btnUpperRadius}px ${this.project.setting.login.btnLowerRadius}px ${this.project.setting.login.btnLowerRadius}px`,
					marginTop: `${this.project.setting.login.btnMarginTop}px `,
					marginBottom: `${this.project.setting.login.btnMarginBottom}px `,
				}
			},
			//同步客多赞   这里目前不好用  暂时注释掉了
			async syncUserToken(userCode, userToken, sitenum) {
				// let uri = `/horse/sync.aspx?userCode=${userCode}&sitenum=${sitenum}&userToken=${userToken}`;
				// let param = {};
				// //////console.log(uri ,param);
				// let res = requestMall(uri, param, 'GET')

				// //////console.log(res);
			},
			//这里判断一下只自动注册 还是填写信息后注册
			toRegist() {
				let autoRegister = uni.getStorageSync("autoRegister");
				console.log("==============>登录页  是否自动注册" + autoRegister);
				//console.log('点击注册--->', autoRegister);
				if (autoRegister == '1') { //开启了自动注册
					//需要写一个全局的注册了
					this.regist(); //直接调用自动注册 ,开始自动注册
				} else {
					//跳转到注册页面
					// uni.navigateTo({
					// 	url: "/pages/index/user/regist",
					// });									
					uni.navigateTo({
						url: "/pages/index/user/improveInfo",
					});
				}


			},
			//自动注册一个新账号,成功后返回首页
			async regist() {
				////console.log('this.openid--->', this.openid);
				let runMode = uni.getStorageSync("runMode"); //1 h5  2小程序  3公众号
				let that = this;
				that.openid = uni.getStorageSync("userOpenid");
				if (that.openid == "") {
					console.log("==============>登录页 没有获取到openid");
					// uni.showModal({
					// 	title: "",
					// 	content: '没有获取到openid,请清理缓存重新进入',
					// 	showCancel: false,
					// });
					return; //后台也是没openid不允许注册 所以直接这里不调用
				}
				let code = "86C64761F192EA595591B4D473E87F0C"
				let uri = "/tools/postvb.ashx";
				let param = {
					act: "addUserDuihuan", //登录页面login的自动注册
					code: code,
					shopid: this.sitenum,
					kh: this.userCode,
					sitenum: this.sitenum,
					weixin: this.openid, //这个是公众号的openid
					openid: '', //这个是小程序的openid
					headimage: this.userHeadImg,
					xm: this.userName,
					sblx: 'ddm'
				};
				////console.log('入参---------->', param);
				let res = await requestWpt(uri, param)
				console.log('自动注册返回->', res);
				if (res.status == '1') { //注册成功
					uni.setStorageSync("userCode", res.account); //会员注册成功后自动登录后返回数据
					uni.setStorageSync("userToken", res.token);
					uni.setStorageSync("userOpenid", res.openid);
					uni.setStorageSync("userInfo", JSON.stringify(res)); //所有返回的内容都存这里 总有需要的时候
					// that.syncUserToken(res.kh, res.token, this.sitenum);
					// 登录成功,设置token				
					that.setToken(res.token);
					//回到首页
					//defaultPage(this); //根据规则 返回首页或潜客首页
					// uni.switchTab({
					// 	url: '/pages/index/tabbar/home'
					// })
				} else if (res.status == '2') { //已经注册过的用户
					uni.setStorageSync("userCode", res.account); //会员发起注册发现已经注册后自动登录成功后返回数据
					uni.setStorageSync("userToken", res.token);
					uni.setStorageSync("userOpenid", res.openid);
					uni.setStorageSync("userInfo", JSON.stringify(res)); //所有返回的内容都存这里 总有需要的时候
					// that.syncUserToken(res.kh, res.token, this.sitenum);
					// 登录成功,设置token				
					that.setToken(res.token);
					//回到首页
					//defaultPage(this); //根据规则 返回首页或潜客首页
					// uni.switchTab({
					// 	url: '/pages/index/tabbar/home'
					// })
				} else { //失败则提示
					uni.showModal({
						title: "登录失败",
						content: res.rsg,
						showCancel: false,
					});

				}

			},

			// 会员账号密码登录
			async login() {
				let that = this;

				//判断下是否同意协议
				if (this.checked == false) {
					uni.showModal({
						title: "",
						content: '请您先阅读并同意协议',
						showCancel: false,
					});
					return;
				}

				let smsCode = "";
				if (this.login_model == 'sms') {
					smsCode = this.password; //如果是验证码登录 那么密码框填写的就是验证码
					//要校验一下这里账号是不是手机 不是直接拦截掉
					//不足11位 不是1开始 不是纯数字的也不允许
					if (!this.isValidPhoneNumber(this.account)) {
						uni.showModal({
							title: "",
							content: '手机号码格式不正确',
							showCancel: false,
						});
						return;
					}
					if (this.password == "") {
						uni.showModal({
							title: "",
							content: '请填写验证码',
							showCancel: false,
						});
						return;
					}
				} else {
					if (this.account == "" || this.password == "") {
						uni.showModal({
							title: "",
							content: '请填写账号和密码',
							showCancel: false,
						});
						return;
					}
				}

				uni.showLoading({
					title: "正在登录中...",
					mask: true, //是否显示透明蒙层，防止触摸穿透，默认为false
				});
				// 设置定时器，例如3秒后关闭加载提示
				setTimeout(function() {
					//console.log("设置定时器，例如3秒后关闭加载提示");
					uni.hideLoading(); // 3秒后关闭加载提示
				}, 3000);

				let systemInfo = uni.getSystemInfoSync();
				let runMode = uni.getStorageSync("runMode"); //1 h5  2小程序  3公众号
				let uri = "/horse/tools/post.ashx?act=login";
				let param = {
					act: "login",
					usernum: this.account,
					userpwd: this.password,
					smsCode: smsCode, //短信验证码
					openid: that.openid, //这里是公众号还是小程序的
					sitenum: this.sitenum,
					nickName: this.userName, // '低代码平台', //经常多人登录微信，这里存着登录人的微信名字，方便确认谁干的
					headImgurl: '', //替换会员头像
					phoneInfo: systemInfo.brand + ' ' + systemInfo.model + ' ' + systemInfo.system + ' ' +
						systemInfo.platform, //设备类型					
					runMode: runMode, //1 h5  2小程序  3公众号 
				};
				//console.log("正在登录中param", param);
				let res = await requestMall(uri, param)

				uni.hideLoading(); //关闭等待动画

				//console.log("正在登录中res", res);
				if (res.status == '1') { //登录成功

					uni.setStorageSync("userCode", res.kh); //通过账号密码登录成功后返回数据
					uni.setStorageSync("userToken", res.token);
					uni.setStorageSync("userOpenid", res.openid);
					uni.setStorageSync("userInfo", JSON.stringify(res)); //所有返回的内容都存这里 总有需要的时候

					that.syncUserToken(res.kh, res.token, this.sitenum);

					// 登录成功,设置token				
					that.setToken(res.token);
					console.log("正在登录中");
					//defaultPage(); //根据规则 返回首页或潜客首页
					// uni.switchTab({
					// 	url: '/pages/index/tabbar/home'
					// })
					//uni.navigateBack(); //后退 回到个人中心

				} else { //失败则提示
					uni.showModal({
						title: "登录失败",
						content: res.msg,
						showCancel: false,
					});

				}

			},
			//页面加载以后初始化 获取微信公众号openid
			init() {
				let url = location.href;
				this.userCode = uni.getStorageSync("userCode"); //获取本地是否已经缓存会员卡号,如果有 则表示已经登录
				////console.log('判断会员是否登录了', this.userCode);
				if (this.userCode == "") { //没登录  注意 这里有个bug  实际上应该判断为null  第一次打开应该是null 商户参数错误
					////console.log('没登录');
					if (this.code == null || this.code == "") { //没有code
						if (this.sitenum == "" || this.appid == "") {
							alert("商户参数错误或appid设置错误" + this.appid + " " + this.sitenum); //如果h5模式下 这个提示正常
							return false;
						} else {
							this.uriReload();
						}
					} else { //拿到了code
						this.chkWx(this.code);
					}
				} else {
					//alert("如果已经登录了,那么后退 没必要去登录页");
					//如果已经登录了,那么后退 没必要去登录页
					//defaultPage(this); //根据规则 返回首页或潜客首页
					// uni.switchTab({
					// 	url: '/pages/index/tabbar/home'
					// })

				}
			},
			uriReload() {
				////console.log('调用open.weixin.qq.com');
				var uri = location.href;
				uri = encodeURIComponent(uri);
				uri =
					"https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
					this.appid +
					"&redirect_uri=" +
					uri +
					"&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
				// //////console.log("code_uri", uri);
				location.replace(uri);
			},
			async chkWx(code) {
				let that = this;
				//let uri = "/horse/tools/post.ashx?act=chkWx";
				let uri = "/tools/wxMessage_ajax.ashx?act=chkWx";
				let param = {
					act: 'chkWx',
					code: code,
					sitenum: this.sitenum
				};
				////console.log('通过code换openid入参---->', param);
				//let result = await requestMall(uri, param)
				let result = await requestWpt(uri, param)
				////console.log('用code获取用户信息------->', result);
				if (result == undefined) {
					uni.showModal({
						title: "",
						content: "微信登录出错，请您进入公众号后点击菜单",
						showCancel: false,
					});
					//强制重新调用

				} else {
					////console.log('用code获取用户信息result.status------->', result.status);
					if (result.status == 1) {
						uni.showModal({
							title: "",
							content: result.msg,
							showCancel: false,
						});
						//登录页面 通过code换openid登录 似乎这个没啥用
						if (result.openid != "") {
							that.openid = result.openid;
							uni.setStorageSync("userOpenid", result.openid);
						}
						uni.setStorageSync("userCode", result.kh); //通过微信openid登录成功后返回数据
						uni.setStorageSync("userToken", result.token); //接口会返回最新的token
						uni.setStorageSync("userInfo", JSON.stringify(result)); //所有返回的内容都存这里 总有需要的时候


						//成功后直接跳转到首页
						let projectId = uni.getStorageSync("projectId");
						this.$jump({
							name: "home",
							data: {
								projectId: projectId
							},
						});
					} else if (result.status == 3) {
						uni.setStorageSync("userOpenid", result.openid);
						that.openid = result.openid;
						that.userName = result.name; //微信的昵称
						that.userHeadImg = result.img //微信的头像
						////console.log('还没注册--->', that.autoRegister);

						//that.regist(); //直接调用自动注册 ,开始自动注册

						if (that.autoRegister == '1') {
							that.regist(); //直接调用自动注册 ,开始自动注册
						} else {
							//首页?

						}

					} else {
						////console.log('其他情况-->', result.status);
						//alert(result.msg);

					}
				}
			},
			isValidPhoneNumber(phoneNumber) {
				const regex = /^1[3-9]\d{9}$/;
				return regex.test(phoneNumber);
			},
			//获取短信验证码
			async getCode() {
				let that = this;
				if (!that.btnDisabled) {
					return false;
				}
				that.btnDisabled = false; //获取验证码按钮是否可以点击
				if (this.account == "") {
					uni.showModal({
						title: "",
						content: '请填写手机号',
						showCancel: false,
					});
					that.btnDisabled = true; //获取验证码按钮是否可以点击
					return;
				}
				//不足11位 不是1开始 不是纯数字的也不允许
				if (!this.isValidPhoneNumber(this.account)) {
					uni.showModal({
						title: "",
						content: '手机号码格式不正确',
						showCancel: false,
					});
					that.btnDisabled = true; //获取验证码按钮是否可以点击
					return;
				}

				uni.showLoading({
					title: "发送中...",
					mask: true, //是否显示透明蒙层，防止触摸穿透，默认为false
				});


				//加个遮罩层
				// wx.showToast({
				//   title: '加载中',
				//   icon: 'loading',
				//   duration: 5000
				// })

				// if (app.globalData.tixianTimestamp != 0 && new Date().getTime() - app.globalData.tixianTimestamp < 1000 * 5) {
				//   //五秒内只能点击一次
				//   wx.showToast({
				//     title: '请不要频繁的操作',
				//     icon: 'none',
				//     duration: 3000
				//   })
				//   return false;
				// }

				//app.globalData.tixianTimestamp = new Date().getTime(); //记录本次提现的时间
				let uri = "/horse/tools/post.ashx";
				let param = {
					act: "user_verify_smscode",
					tel: this.account, //手机号码
					type: 'login', //验证码的来源  登录 优惠券coupon 注册regist
					sitenum: this.sitenum,

				};
				////console.log('入参---------->', param);
				//let res = await requestWpt(uri, param)
				let res = await requestMall(uri, param)

				////console.log('获取到客多赞返回---------->', res);
				var num = 61; //下一次获取短信验证码的时间间隔 之前是60 现在改为180
				var timer = setInterval(function() {
					num--;
					if (num <= 0) {
						clearInterval(timer);
						that.btnTitle = "获取验证码";
						that.btnDisabled = true;

					} else {
						that.btnTitle = num + "s";
					}
				}, 1000)

				uni.hideLoading(); //关闭等待动画

				if (res.status == '1') {


				} else {
					uni.showModal({
						title: "",
						content: res.msg,
						showCancel: false,
					});
					// uni.showToast({
					// 	title: res.msg,
					// 	icon: 'error',
					// 	duration: 1500
					// })
				}

			},






		},
	};
</script>

<style lang="scss" scoped>
	page {
		background-color: #eee;
	}

	input::placeholder {
		color: var(--placeholder-color);
	}

	.loginTitle {
		width: 100%;
		height: 30px;
		font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
		font-weight: 700;
		font-size: 24px;
		color: #000000;
		line-height: 0px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		// margin-top: 356px;
	}


	.loginTitle2 {
		width: 100%;
		height: 30px;
		font-family: Alibaba PuHuiTi 3.0, Alibaba PuHuiTi 30;
		font-weight: 400;
		font-size: 16px;
		color: #808080;
		line-height: 0px;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}



	.btn {
		background: rgb(188, 175, 166);
		border-radius: 50px;
		text-align: center;
		color: white;
		font-size: 16px;
		margin-top: 10px;
		width: 90%;
	}





	.login {
		display: flex;
		flex-direction: column;
		align-items: center;
		height: 100%;
		color: #d2d2d2;

		background-repeat: no-repeat; //取消重复平铺
		background-position: top; //将背景图片定位到顶部	
		background-size: 100%; //是不是应该加一个图片高度的设置,这样可以控制

		.login-logo {
			// min-height: 60px;
			// min-width: 60px;
			margin-top: 80px;
			margin-bottom: 70px;
			// border-radius: 50%;
		}

		//用户名和密码输入框
		.login-field {
			height: 48px;
			border-radius: 23px;
			margin-bottom: 10px;
			padding-left: 24px;

			// opacity: 0.1;

			// display: flex;
			// align-items: center;
			input {
				height: 100%;
				outline: none;
				border: 0;
				font-size: 16px;
				color: #383838;
				background: transparent;
			}

			input::-webkit-input-placeholder,
			textarea::-webkit-input-placeholder {
				color: #dbd9dc;
				font-size: 14px;
				font-weight: 700;
			}

			i {
				font-size: 20px;
				margin-right: 5px;
			}
		}


		.telPwdCss {
			width: 95%;
		}

		.login-line {
			position: relative;
			margin-top: 100px;
			font-size: 12px;

			&::after {
				content: "";
				position: absolute;
				top: 50%;
				right: 110px;
				transform: translateY(-50%);
				width: 60px;
				height: 1px;
				background: #d2d2d2;
			}

			&::before {
				content: "";
				position: absolute;
				top: 50%;
				left: 110px;
				transform: translateY(-50%);
				width: 60px;
				height: 1px;
				background: #d2d2d2;
			}
		}

		.login-section {
			display: flex;
			justify-content: space-around;
			width: 250px;
			margin-top: 20px;

			.login-section-weixin {
				color: #28c445;
				font-size: 36px;
			}

			.login-section-qq {
				color: #23a0f0;
				font-size: 38px;
			}
		}
	}

	.group_regist {
		margin-top: 20px;
		padding-left: 87rpx;
		padding-right: 86rpx;
	}


	.image_agreement {
		margin-top: 3rpx;
		width: 30rpx;
		height: 30rpx;
	}

	.group_agreement {
		margin-top: 10px;
		padding-left: 87rpx;
		padding-right: 86rpx;

	}

	.text_agreement {
		margin-bottom: 10rpx;
		// color: #ffffff99;
		font-size: 12px;
		font-family: '.AppleSystemUIFont';
		line-height: 15px;
		letter-spacing: -2px;

	}

	.text_agreement_2 {
		margin-bottom: 3rpx;
		margin-left: 5px;
		margin-right: 5px;
		// color: #ffffff;
		font-size: 12px;
		font-family: '.AppleSystemUIFont';
		line-height: 15px;
		letter-spacing: -2px;

	}


	// 获取短信验证码的区域
	.text_sms {
		width: 100px;
		height: 100%;
		overflow-wrap: break-word;
		font-size: 14px;
		letter-spacing: 1px;
		font-family: PingFangSC-Medium;
		font-weight: 500;
		text-align: left;
		white-space: nowrap;
		line-height: 56px;
		margin: auto;
		align-items: center;
		justify-content: center;
	}



	// 协议选中的样式
	.checkbox_1 {
		width: 32rpx;
		height: 32rpx;
		line-height: 50rpx;
		//background: url(https://kdz-2023-photo-001.oss-cn-shanghai.aliyuncs.com/upload/202405/23/518001-202405231435457525.png) 100% no-repeat;
		//background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		margin-right: 5px;
	}

	//协议没有选中
	.checkbox_10 {
		width: 18px;
		height: 18px;
		line-height: 26px;
		border-radius: 10px;
		//background: url(https://kdz-2023-photo-001.oss-cn-shanghai.aliyuncs.com/upload/202309/01/138274-202309011116349945.png) 100% no-repeat;
		// background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		margin-right: 5px;
	}


	.line {
		width: 100%;
		margin-top: -10px;
		margin-bottom: 20px;
		height: 1px;
		background: #CCCCCC;
		border-radius: 30rpx;
	}

	//底部logo的样式
	.login-bottom-logo {
		height: 32px;
		width: 32px;
		// margin-top: 80px;
		// margin-bottom: 70px;

	}
</style>